import React from "react";
import { FormikProvider, Form, Field } from "formik";
import CountryInput from "../../../Common/Inputs/CountryInput/CountryInput";
import LoadingSpinner from "../../../Common/Loading/LoadingSpinner";
import DrawerPortal from "../../../Common/SidebarDrawer/DrawerPortal";

const AddressDrawer = ({ 
    drawerRef, 
    formik, 
    isEditing, 
    isLoading,
    onHideDrawer
}) => {
    return (
        <DrawerPortal ref={drawerRef} className="w-full max-w-md" direction="end">
            <div className="p-6">
                <h3 className="text-xl font-semibold mb-4">
                    {isEditing ? 'Modifier l\'adresse' : 'Ajouter une adresse'}
                </h3>
                <FormikProvider value={formik}>
                    <Form className="space-y-4">
                        <div className="form-control">
                            <label htmlFor="street" className="label">
                                <span className="label-text">Adresse</span>
                            </label>
                            <Field
                                id="street"
                                name="street"
                                placeholder="Numéro et nom de rue"
                                className={`input input-bordered w-full ${formik.errors?.street ? 'input-error' : ''}`}
                                aria-invalid={formik.errors?.street ? 'true' : 'false'}
                                aria-describedby={formik.errors?.street ? 'street-error' : undefined}
                            />
                            {formik.errors?.street && (
                                <label className="label">
                                    <span id="street-error" className="label-text-alt text-error">
                                        {formik.errors.street}
                                    </span>
                                </label>
                            )}
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <div className="form-control">
                                <label htmlFor="city" className="label">
                                    <span className="label-text">Ville</span>
                                </label>
                                <Field
                                    id="city"
                                    name="city"
                                    placeholder="Ville"
                                    className={`input input-bordered w-full ${formik.errors?.city ? 'input-error' : ''}`}
                                    aria-invalid={formik.errors?.city ? 'true' : 'false'}
                                    aria-describedby={formik.errors?.city ? 'city-error' : undefined}
                                />
                                {formik.errors?.city && (
                                    <label className="label">
                                        <span id="city-error" className="label-text-alt text-error">
                                            {formik.errors.city}
                                        </span>
                                    </label>
                                )}
                            </div>

                            <div className="form-control">
                                <label htmlFor="postcode" className="label">
                                    <span className="label-text">Code Postal</span>
                                </label>
                                <Field
                                    id="postcode"
                                    name="postcode"
                                    placeholder="Code Postal"
                                    className={`input input-bordered w-full ${formik.errors?.postcode ? 'input-error' : ''}`}
                                    aria-invalid={formik.errors?.postcode ? 'true' : 'false'}
                                    aria-describedby={formik.errors?.postcode ? 'postcode-error' : undefined}
                                />
                                {formik.errors?.postcode && (
                                    <label className="label">
                                        <span id="postcode-error" className="label-text-alt text-error">
                                            {formik.errors.postcode}
                                        </span>
                                    </label>
                                )}
                            </div>
                        </div>

                        <div className="form-control">
                            <label htmlFor="state" className="label">
                                <span className="label-text">État/Région</span>
                            </label>
                            <Field
                                id="state"
                                name="state"
                                placeholder="État ou région"
                                className={`input input-bordered w-full ${formik.errors?.state ? 'input-error' : ''}`}
                                aria-invalid={formik.errors?.state ? 'true' : 'false'}
                                aria-describedby={formik.errors?.state ? 'state-error' : undefined}
                            />
                            {formik.errors?.state && (
                                <label className="label">
                                    <span id="state-error" className="label-text-alt text-error">
                                        {formik.errors.state}
                                    </span>
                                </label>
                            )}
                        </div>

                        <div className="form-control">
                            <CountryInput
                                id="isoCountry"
                                name="isoCountry"
                                className={`${formik.errors?.isoCountry ? 'select-error' : ''}`}
                                aria-invalid={formik.errors?.isoCountry ? 'true' : 'false'}
                                aria-describedby={formik.errors?.isoCountry ? 'isoCountry-error' : undefined}
                            />
                            {formik.errors?.isoCountry && (
                                <label className="label">
                                    <span id="isoCountry-error" className="label-text-alt text-error">
                                        {formik.errors.isoCountry}
                                    </span>
                                </label>
                            )}
                        </div>

                        <div className="form-control">
                            <label className="label cursor-pointer">
                                <span className="label-text">Adresse par défaut</span>
                                <Field
                                    name="isPrimary"
                                    type="checkbox"
                                    className="checkbox checkbox-primary"
                                />
                            </label>
                        </div>

                        <div className="flex justify-end gap-2 mt-6">
                            <button
                                type="button"
                                onClick={onHideDrawer}
                                className="btn btn-ghost"
                            >
                                Annuler
                            </button>
                            <button
                                type="submit"
                                onClick={formik.handleSubmit}
                                disabled={formik.isSubmitting || isLoading}
                                className="btn btn-primary"
                            >
                                {isLoading ? (
                                    <LoadingSpinner style="small"/>
                                ) : isEditing ? (
                                    'Modifier'
                                ) : (
                                    'Ajouter'
                                )}
                            </button>
                        </div>
                    </Form>
                </FormikProvider>
            </div>
        </DrawerPortal>
    );
};

export default AddressDrawer; 